var _style, _g, _circle, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEvo7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 487.9 98.9",
    style: {
      enableBackground: "new 0 0 487.9 98.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DF1F26;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#DE2227;}\r\n\t.st3{fill:#DE2227;stroke:#DE2227;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,87.1l7.4-10.7c5,4.4,10.6,6.6,16.9,6.6c4.4,0,8-1.1,10.8-3.4c2.8-2.3,4.6-5.2,5.5-8.8H16.6v-12h25.4 c-0.9-3.6-2.7-6.5-5.6-8.8c-2.9-2.2-6.5-3.4-10.8-3.4c-5.7,0-11.1,2.3-16.4,6.9l-7-11.3c5.8-6.1,13.8-9.1,24-9.1 c9.7,0,17.5,3,23.2,9c5.7,6,8.6,13.5,8.6,22.4c0,9.3-3,16.9-9.1,23c-6.1,6-13.9,9.1-23.4,9.1C16.6,96.6,8.5,93.4,1.3,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,95.5V34.1h22.6c6.3,0,11.4,1.4,15.2,4.2c3.8,2.8,5.7,6.7,5.7,11.9c0,2.6-0.6,5.1-1.9,7.5 c-1.3,2.4-3,4.2-5.2,5.5v0.2c3.3,1,5.7,2.8,7.3,5.4c1.6,2.6,2.4,5.4,2.4,8.5c0,6.2-2.2,10.9-6.6,13.8c-4.4,3-10,4.5-16.8,4.5H71.9z  M86.9,57.9h7.7c1.8,0,3.1-0.5,4-1.6c0.9-1.1,1.4-2.4,1.4-4c0-1.5-0.5-2.8-1.4-3.8c-0.9-1-2.4-1.5-4.3-1.5h-7.5V57.9z M86.9,82.7h9 c2.1,0,3.7-0.6,4.8-1.8c1.1-1.2,1.7-2.8,1.7-4.6c0-1.8-0.5-3.3-1.6-4.5c-1.1-1.2-2.7-1.8-4.8-1.8h-9.1V82.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.4,64.4c0-8.9,3.1-16.3,9.2-22.3c6.1-6,13.8-9,23-9c9.2,0,16.9,3,23,9c6.1,6,9.2,13.5,9.2,22.3 c0,9.1-3.1,16.7-9.2,22.9c-6.1,6.2-13.8,9.2-23,9.2c-9.2,0-16.9-3.1-23-9.2C131.5,81.2,128.4,73.5,128.4,64.4z M144,64.4 c0,5.2,1.6,9.6,4.8,13.1c3.2,3.5,7.1,5.3,11.8,5.3c4.6,0,8.6-1.8,11.8-5.3c3.2-3.5,4.8-7.9,4.8-13.1c0-5-1.6-9.2-4.8-12.5 c-3.2-3.4-7.1-5.1-11.8-5.1c-4.6,0-8.6,1.7-11.8,5.1C145.6,55.3,144,59.5,144,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.3,64.7c0-9.1,3-16.6,9.1-22.6c6-6,13.8-9,23.2-9c4.3,0,8.5,0.7,12.5,2.2c4.1,1.5,7.6,3.6,10.5,6.5 l-7,11.3c-2.1-1.8-4.5-3.3-7.3-4.5c-2.8-1.2-5.5-1.8-8.1-1.8c-5.7,0-10.1,1.7-13,5.1c-2.9,3.4-4.4,7.5-4.4,12.4c0,5,1.5,9.3,4.5,13 c3,3.7,7.3,5.5,12.8,5.5c5.8,0,11.3-2.5,16.3-7.6l7.7,11c-6.6,6.9-14.9,10.3-24.8,10.3c-9.7,0-17.5-3-23.4-9 C206.2,81.6,203.3,74,203.3,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.2,95.5V34.1h38.5V47h-23.5v11.2H306v12.9h-18.7v11.6h24.7v12.9H272.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.6,95.5V34.1h15.1l18.5,40.2c1.1-4.1,18.8-40.2,18.8-40.2h14.7v61.4H379v-38l0,0 c-1.4,4.3-12.5,28.1-12.5,28.1h-12.9l-12-28.1v38H326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.4,95.5V34.1h15v19h10.5c6,0,10.8,2,14.5,6c3.7,4,5.5,9.1,5.5,15.3c0,6.2-1.8,11.3-5.5,15.2 c-3.7,4-8.5,5.9-14.5,5.9H408.4z M423.5,82.7h7.6c2.4,0,4.3-0.7,5.6-2.2c1.3-1.5,2-3.5,2-6c0-2.5-0.7-4.6-2-6.1 c-1.3-1.5-3.3-2.3-5.8-2.3h-7.4V82.7z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 463.1,
    cy: 26,
    r: 19.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M466.3,20.8c0.7-1.4,1-2.1-0.2-2.1h-9.7v-3.6h15.6V18l-14,26h-4.3L466.3,20.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M462.9,46.3c-11.7,0-21.1-9.5-21.1-21.1c0-11.7,9.5-21.1,21.1-21.1c11.7,0,21.1,9.5,21.1,21.1 C484,36.8,474.6,46.3,462.9,46.3z M462.9,5c-11.1,0-20.1,9-20.1,20.1c0,11.1,9,20.1,20.1,20.1c11.1,0,20.1-9,20.1-20.1 C483,14,474,5,462.9,5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEvo7);
export default __webpack_public_path__ + "static/media/logo_evo7.d2c3c2155e95c14cc623a4ca06dde699.svg";
export { ForwardRef as ReactComponent };